
import { Component, Vue } from "vue-property-decorator";
import { isMobile, isIOS, isTablet } from "mobile-device-detect";
import {
  Alert,
  LotPosition,
  PrintRequest,
  PlatmapInfo,
  Amenity,
  Platmap,
  LotDetails,
  HeaderData,
  PlatmapsInfo,
  NeighborhoodInfo,
  LotDetail,
  NeighborhoodsLots,
  NeighborhoodPlatMap,
  LotInfo,
  QmiDetails,
  FutureHome,
  CommunityFutureHomePlans,
} from "./types";
import {
  ModalType,
  LanscapeAlert,
  OrientationType,
  Settings,
  Status,
  UrlFilterList,
  PreAreaNameUrl,
  FutureData,
} from "./constant";
import {
  apiPrintPDF,
  apiFetchPlatmapInfo,
  apiFetchPlatmapsInfo,
  apiFetchPlatmap,
  apiFetchLots,
  apiFetchPlatmapCordinates,
} from "./api";
import PlatMapPage from "./components/views/PlatMapPage.vue";
import PlatMapModal from "./components/modal/PlatMapModal.vue";
import PlatmapAmenityModal from "./components/modal/PlatmapAmenityModal.vue";
import ContactInformation from "./components/modal/ContactInformation.vue";
import ThankYouModal from "./components/modal/ThankYouModal.vue";
import Loader from "./components/Loader.vue";
import NotFoundPage from "../src/components/views/404Page.vue";
import PlatMapPrintModal from "../src/components/modal/PlatMapPrintModal.vue";
import { convertToTitleCase } from "./core";

@Component({
  components: {
    PlatMapPage,
    PlatMapModal,
    Loader,
    ContactInformation,
    ThankYouModal,
    PlatmapAmenityModal,
    NotFoundPage,
    PlatMapPrintModal,
  },
})
export default class Root extends Vue {
  $modal!: any;
  $route!: any;
  $router!: any;
  $refs!: any;
  private notFound = false;
  private selectedLotId = "";
  private amenityId = "";
  private selectedHomePlanIds: string[] = [];
  private amenities: string[] = [];
  private allAmenities: Array<Amenity> = [];
  private lotPosition: LotPosition = {} as LotPosition;
  private platmap: Platmap = {} as Platmap;
  private lotDetails: LotDetails = {} as LotDetails;
  private neighborhoodId = "";
  private selectedNeighborhoodIds: Array<string> = [];
  private neighborhoods: Array<NeighborhoodInfo> = [];
  private neighborhoodNames: Array<string> = [];
  private neighborhoodName = "";
  private underlay = false;
  private legends = "";
  private areaId = "";
  private areaName = "";
  private neighborhoodAreaName = "";
  private communityDisplayName = "";
  private communityId = "";
  private communityName = "";
  private loading = false;
  private printOptionSelected = false;
  private alert: Alert = {} as Alert;
  private topPosition = 0;
  private siblingSelected = false;
  private isOpenPrintModal = false;
  private isOpenFooter = true;
  private centerLatitude = 0;
  private centerLongitude = 0;
  private currentNeighborhoodCenterLatitude = 0;
  private currentNeighborhoodCenterLongitude = 0;
  private zoomLevel = 0;
  private hasMobile = !!(isMobile && !isTablet);
  private selectQmiData = {} as QmiDetails;
  private futureHomePlans = {} as CommunityFutureHomePlans;
  private futureLotIds = [] as string[];
  created() {
    const urlNeighborhoodName = this.$route.query[UrlFilterList.NEIGHBORHOOD];
    if (Array.isArray(urlNeighborhoodName)) {
      this.neighborhoodNames.push(urlNeighborhoodName[0]);
    } else {
      this.neighborhoodNames.push(urlNeighborhoodName);
    }
    this.areaName = this.$route.params.areaName || "";
    if (this.checkAreaNameFormate()) {
      // this.areaName = this.areaName.substring(10);
      this.communityName = this.$route.params.communityName || "";
      this.fetchPlatmapInfo(this.areaName, this.communityName, this.neighborhoodNames);
    } else {
      this.loading = false;
      this.notFound = true;
    }
  }

  checkAreaNameFormate() {
    if (this.areaName.length > 10) {
      const preAreaName = this.areaName.substring(0, 9);
      const preParts = preAreaName.split("-");
      return (
        `${preParts[0].toLowerCase()}-${preParts[1].toLowerCase()}` === PreAreaNameUrl
      );
    }
    return false;
  }
  mounted() {
    // 7/16/21 - CM - removed orientation checks per Barbara
    //window.addEventListener("orientationchange", this.handleOrientationChange);
    window.addEventListener("resize", () => {
      this.$refs.platMapPage && this.$refs.platMapPage.recalculateSidebarHeight();
    });
    //if (isMobile) this.handleOrientationChange();
  }

  formatCityCommunityNeighborName(name: string) {
    const alphabet = [] as string[];
    name.split("").forEach((c) => {
      if (
        (c >= "0" && c <= "9") ||
        (c >= "A" && c <= "Z") ||
        (c >= "a" && c <= "z") ||
        c == "-" ||
        c == " " ||
        c == "/"
      ) {
        alphabet.push(c);
      }
    });
    const changeName = alphabet
      .join("")
      .replaceAll("/", "-")
      .replaceAll(" ", "-")
      .replaceAll("--", "-")
      .replaceAll("--", "-")
      .toLowerCase();
    return changeName;
  }
  handleOrientationChange() {
    const orientation = isIOS ? this.getIOSOrientation() : window.screen.orientation.type;
    const fullHeight = isIOS ? this.getHeightIOS(orientation) : window.screen.height;
    const fullWidth = isIOS ? this.getWidthIOS(orientation) : window.screen.width;
    this.onOrientationChange(fullHeight, fullWidth, orientation);
  }

  getIOSOrientation() {
    if (
      window.orientation === Settings.IOS_MIN_ORIENTATION ||
      window.orientation === Settings.IOS_MAX_ORIENTATION
    )
      return OrientationType.LANDSCAPE_PRIMARY;
    else return OrientationType.PORTRAIT_PRIMARY;
  }

  onOrientationChange(fullHeight, fullWidth, orientation) {
    if (
      this.checkForPortrait(fullHeight, fullWidth, orientation) ||
      this.checkForLandscape(fullHeight, fullWidth, orientation)
    ) {
      // this.showAlert(LanscapeAlert());
    } else {
      this.hideAlert();
    }
  }

  updateLotInfo(lotDetail: LotInfo | LotDetail, lotId: string) {
    for (const key of Object.keys(this.futureHomePlans)) {
      const isFutureHomePlans = this.futureHomePlans[key].find(
        (element) => element.job_number === lotId
      );
      if (isFutureHomePlans) {
        if ("lot" in lotDetail) {
          lotDetail.lot.color = "#CBBE98";
          lotDetail.lot.status = Status.FUTURE_HOME;
        } else {
          lotDetail.color = "#CBBE98";
          lotDetail.status = Status.FUTURE_HOME;
        }
      }
    }
  }

  checkForPortrait(fullHeight, fullWidth, orientation) {
    return (
      (orientation === OrientationType.PORTRAIT_PRIMARY &&
        !isTablet &&
        (fullHeight < Settings.PORTRAIT_MIN_HEIGHT ||
          fullWidth > Settings.PORTRAIT_MAX_WIDTH)) ||
      (isTablet && fullWidth < Settings.TABLET_PORTRAIT_MIN_WIDTH)
    );
  }

  checkForLandscape(fullHeight, fullWidth, orientation) {
    return (
      orientation === OrientationType.LANDSCAPE_PRIMARY &&
      (fullHeight < Settings.LANDSCAPE_MAX_HEIGHT ||
        fullWidth < Settings.LANDSCAPE_MIN_WIDTH)
    );
  }

  getHeightIOS(orientation) {
    if (orientation === OrientationType.LANDSCAPE_PRIMARY) return window.screen.width;
    else return window.screen.height;
  }

  getWidthIOS(orientation) {
    if (orientation === OrientationType.LANDSCAPE_PRIMARY) return window.screen.height;
    else return window.screen.width;
  }

  showAlert(alert: Alert) {
    this.alert = alert;
    this.hideLoader();
  }

  hideAlert() {
    this.alert = {} as Alert;
    this.closeModal(ModalType.ALERT);
  }

  openModal(modalName: string) {
    this.$modal.show(modalName);
  }

  closeModal(modalName: string) {
    if (modalName === ModalType.CROPPING_TOOL) {
      this.setPrintModal(false);
    }
    this.$modal.hide(modalName);
  }

  setZoomLevelMapPage(zoomLevel: number) {
    this.zoomLevel = zoomLevel;
  }

  calculateContactInfoTopPosition() {
    const outerHeight =
      isMobile && !isTablet
        ? Settings.TOP_OUTER_HEIGHT_MOBILE
        : Settings.TOP_OUTER_HEIGHT_TABLET;
    const header = document.getElementById("header") as HTMLElement;
    this.topPosition =
      (header && header.clientHeight
        ? header.clientHeight
        : Settings.TOP_OUTER_HEIGHT_TABLET) + outerHeight;
  }

  setLotId(lotId: string, selectedHomePlanIds: string[], lotPosition: LotPosition) {
    this.selectedLotId = lotId;
    // this.selectedHomePlanIds = selectedHomePlanIds;
    this.lotPosition = lotPosition;
  }

  setselectQmiData(selectQmiData: QmiDetails) {
    this.selectQmiData = selectQmiData;
  }
  setAminityId(amenityId: string, lotPosition?: LotPosition) {
    this.amenityId = amenityId;
    if (this.lotPosition) {
      this.lotPosition = lotPosition as LotPosition;
    }
    if (isTablet) {
      const { hideFooter, hideHeader } = this.$refs.platMapPage;
      hideFooter();
      hideHeader();
    }
  }

  handlePrintSelectionClick(printOptionSelected: boolean) {
    this.printOptionSelected = printOptionSelected;
  }

  openPrintModal() {
    const { handlePrintClick } = this.$refs.platMapPage;
    handlePrintClick();
  }

  loadNeighborhood(areaName: string, communityName: string, neighborhoodName: string) {
    this.neighborhoodId = "";
    this.neighborhoodName = neighborhoodName;
    this.areaName = areaName;
    this.communityName = communityName;
    this.siblingSelected = true;
    this.closeAmenityInfo();
    this.handleCloseLotInfo();
    let query = this.$route.query.kiosk ? { kiosk: this.$route.query.kiosk } : {};
    this.$router.replace({
      path: `/custom-homes/${areaName}/community/${communityName}/${neighborhoodName}/plat`,
      query,
    });
    // this.fetchPlatmapInfo(
    //   this.areaName,
    //   this.communityName,
    //   this.neighborhoodName
    // );
  }

  clearSelectedNeighborhoods() {
    this.selectedNeighborhoodIds = [];
  }

  selectNeighborhood(neighborhoodId: string) {
    if (this.selectedNeighborhoodIds.includes(neighborhoodId)) {
      this.clearSelectedNeighborhoods();
    } else {
      this.selectedNeighborhoodIds = [neighborhoodId];
      [
        this.currentNeighborhoodCenterLatitude,
        this.currentNeighborhoodCenterLongitude,
      ] = this.getCurrentNeighborhoodPosition();
    }
  }
  removeMobileHomeTypeFilter() {
    const planNameList = this.$refs.platMapPage.listPlanNameMobileFilter;
    const qmiList = this.$refs.platMapPage.qmiFilterListMobileFilter;
    this.$refs.platMapPage.applyMobileFilters(planNameList, [], qmiList);
  }
  setHomeTypeCount(homeTypeCount: number) {
    if (homeTypeCount < 2) {
      const planNameList = this.$refs.platMapPage.filterPlanNameList;
      const maxPrice = this.$refs.platMapPage.filterMaxPrice;
      const minPrice = this.$refs.platMapPage.filterMinPrice;
      this.$refs.platMapPage.setFilterProperties([], planNameList, maxPrice, minPrice);
      if (this.hasMobile) {
        this.removeMobileHomeTypeFilter();
      }
    }
  }

  updateQmiAddressInUrl() {
    if (!Object.keys(this.selectQmiData).length) {
      const newQuery = { ...this.$route.query };
      newQuery[UrlFilterList.LOT] = [];
      this.$router.push({ query: newQuery }).catch(() => {});
    }
  }

  setNeighborhoodName(neighborhoodName: string) {
    this.neighborhoodName = neighborhoodName;
  }

  setNeighborhoodAreaName(neighborhoodAreaName: string) {
    this.neighborhoodAreaName = neighborhoodAreaName;
  }
  setCommunityName(communityName: string) {
    this.communityDisplayName = communityName;
  }

  setLegends(legends: string) {
    this.legends = legends;
  }

  setAmenities(amenities: Array<string>) {
    this.amenities = amenities;
  }

  setUnderlay(underlay: boolean) {
    this.underlay = underlay;
  }

  setMapCenter(x: number, y: number) {
    this.$refs.platMapPage.setMapCenter(x, y);
  }

  setAllAmenities(allAmenities: Array<Amenity>) {
    this.allAmenities = allAmenities;
  }

  closeLotInfo() {
    this.selectedLotId = "";
    this.selectedHomePlanIds = [];
    this.lotPosition = {} as LotPosition;
    if (isMobile && isTablet) {
      const { showHeader, toolbar } = this.$refs.platMapPage;
      // showFooter();
      // showSidebar();
      if (!toolbar) showHeader();
    }
    this.updateQmiAddressInUrl();
  }
  handleCloseLotInfo() {
    if (this.$refs.platMapModal) {
      const { beforeClose } = this.$refs.platMapModal;
      beforeClose();
    } else this.closeLotInfo();
  }

  closeAmenityInfo() {
    if (this.amenityId && isTablet) {
      const { showHeader, showFooter, showSidebar } = this.$refs.platMapPage;
      showHeader();
      showFooter();
      showSidebar();
    }
    this.amenityId = "";
    if (isMobile) {
      const { showHeader, toolbar } = this.$refs.platMapPage;
      if (!toolbar) showHeader();
    }
  }

  updateLotPosition(lotPosition) {
    this.lotPosition = lotPosition;
  }

  showLoader() {
    this.loading = true;
  }
  hideLoader() {
    this.loading = false;
  }

  isPlatMapValid() {
    return (
      this.platmap.url &&
      this.platmap.svg_html &&
      this.platmap.display_status === "active"
    );
  }

  async printPDF(platmap: string) {
    try {
      let currentPDFTitle = this.communityName;
      if (this.selectedNeighborhoodIds.length) {
        let currentNeighborhood = this.neighborhoods.filter(
          (element) => element.neighborhood_code === this.selectedNeighborhoodIds[0]
        );
        currentPDFTitle = currentNeighborhood[0].neighborhood_name;
      }
      const legends = 'Available,Quick Move-In,Future Home,Sold,Model';
      const printRequest: PrintRequest = {
        areaId: this.areaId,
        legend: this.amenities.length
          ? legends.concat(",", "Amenity")
          : legends,
        neighborhoodName: this.communityDisplayName,
        platMap: platmap,
        printTime: "",
      };
      this.closeModal(ModalType.CROPPING_TOOL);
      apiPrintPDF(printRequest);
      this.openModal(ModalType.THANK_YOU);
    } catch (error) {
      this.loading = false;
    }
  }

  addCityStateTitle(state: string, city: string) {
    const communityName = convertToTitleCase(`${this.communityName}`);
    if (state && city) {
      state = state.toUpperCase();
      city = convertToTitleCase(`${city}`);
      const location = `${city}, ${state}`;
      const newTitle = `Explore a Plat Map of ${communityName} - ${location}`;
      const metaDescription = `Explore neighborhoods and lots in ${communityName}, ${location}. See available lots, homes under construction and amenities on a map`;
      document.title = newTitle;
      const element = document.head.querySelector('meta[name="description"]');
      if (element instanceof HTMLMetaElement) {
        element.content = metaDescription;
      }
    }
  }

  async fetchPlatmapInfo(
    areaName: string,
    communityName: string,
    neighborhoodNames: string[]
  ) {
    try {
      this.loading = true;
      const responses = await apiFetchPlatmapsInfo(areaName, communityName);
      const platMapsInfo = responses.result as PlatmapsInfo;
      platMapsInfo.city = this.formatCityCommunityNeighborName(platMapsInfo.city);
      platMapsInfo.state = this.formatCityCommunityNeighborName(platMapsInfo.state);
      this.areaId = platMapsInfo.area_id;
      this.communityId = platMapsInfo.community_code;
      this.neighborhoods = platMapsInfo.neighborhoods;
      this.neighborhoods.map((neighbor) => {
        neighbor.neighborhood_name = this.formatCityCommunityNeighborName(
          neighbor.neighborhood_name
        );
      });
      this.addCityStateTitle(platMapsInfo.state, platMapsInfo.city);
      this.neighborhoods.forEach((neighborhood) => {
        if (neighborhoodNames.includes(neighborhood.neighborhood_name)) {
          this.selectedNeighborhoodIds.push(neighborhood.neighborhood_code);
        }
      });
      if (!this.selectedNeighborhoodIds.length) {
        const newQuery = { ...this.$route.query };
        newQuery[UrlFilterList.NEIGHBORHOOD] = [];
        this.$router.push({ query: newQuery }).catch(() => {});
      }
    } catch (error) {
      this.loading = false;
      this.notFound = true;
    }
  }

  getFutureLotIds() {
    Object.values(this.futureHomePlans).forEach((plans) => {
      const ids = plans.map((plan) => plan.job_number);
      this.futureLotIds.push(...ids);
    });
  }

  getCurrentNeighborhoodPosition() {
    let currentNeighborhoodLatitude = 0;
    let currentNeighborhoodLongitude = 0;
    const currentNeighborhoodData = this.platmap.neighborhoods.find(
      (neighborhood) => neighborhood.id === this.selectedNeighborhoodIds[0]
    );
    if (currentNeighborhoodData) {
      currentNeighborhoodLatitude = currentNeighborhoodData?.latitude;
      currentNeighborhoodLongitude = currentNeighborhoodData?.longitude;
    } else {
      const firstNeighborhood = this.platmap.neighborhoods[0];
      currentNeighborhoodLatitude = firstNeighborhood.latitude;
      currentNeighborhoodLongitude = firstNeighborhood.longitude;
    }
    return [currentNeighborhoodLatitude, currentNeighborhoodLongitude];
  }

  fetchFutureHomePlans(neighborhoods: NeighborhoodsLots) {
    const neighborhoodFuturePlan = [] as FutureHome[];
    neighborhoods.lots.forEach((lot) => {
      if (lot.isFuturePlan) {
        neighborhoodFuturePlan.push({
          elevation: lot.elevation,
          address: lot.address,
          plan_name: lot.plan_name,
          job_number: lot.id,
        });
      }
    });
    if (neighborhoodFuturePlan.length)
      this.futureHomePlans[neighborhoods.neighborhood_code] = neighborhoodFuturePlan;
  }
  async fetchPlatmap(neighborhoodId: string, communityCode: string, header: HeaderData) {
    try {
      const resPlatmap = await apiFetchPlatmap(neighborhoodId, communityCode);
      this.platmap = resPlatmap.result as Platmap;
      if (this.isPlatMapValid()) {
        const promises = this.neighborhoods.map((neighborhood) =>
          apiFetchLots(
            neighborhood.neighborhood_code,
            this.platmap.neighborhoods.find(
              (nb) => nb.id === neighborhood.neighborhood_code
            )?.nb_unit_type || ""
          )
        );
        const responses = await Promise.all(
          promises.map((promise) => promise.catch((error) => error))
        );
        const neighborhoods = [] as NeighborhoodsLots[];
        responses.forEach((response, idx) => {
          if (response.result) {
            const neighborhoodLots = {
              neighborhood_code: this.neighborhoods[idx].neighborhood_code,
              lots: response.result.lots as LotDetail[],
            } as NeighborhoodsLots;
            neighborhoods.push(neighborhoodLots);
            this.fetchFutureHomePlans(neighborhoodLots);
          }
        });
        this.getFutureLotIds();
        this.lotDetails.neighborhoods = neighborhoods;
        const activeNeighborhood = responses.filter((response) => !!response.result);
        this.lotDetails.amenity = activeNeighborhood[0].result.amenity as Amenity[];
        this.setAllAmenities(activeNeighborhood[0].result.amenity as Amenity[]);
        this.setUnderlay(this.platmap.underlay_on);
        this.centerLatitude = this.platmap.center_latitude;
        this.centerLongitude = this.platmap.center_longitude;
        [
          this.currentNeighborhoodCenterLatitude,
          this.currentNeighborhoodCenterLongitude,
        ] = this.getCurrentNeighborhoodPosition();
      } else {
        this.notFound = true;
      }
      this.hideLoader();
    } catch (error) {
      this.platmap = {} as Platmap;
      this.lotDetails = {} as LotDetails;
      this.hideLoader();
      this.notFound = true;
    }
  }

  showPlanFutureLotFlyout(lotInfo: LotInfo, lotId: string) {
    const futurePlan = [] as FutureHome[];
    if (Object.keys(lotInfo).length && this.futureLotIds.includes(lotId)) {
      Object.values(this.futureHomePlans).forEach((plan) => futurePlan.push(...plan));
      const showPlanOnFlyout = futurePlan.find((plan) => plan.job_number === lotId);
      const planData = lotInfo.homes_plans.find(
        (plan) => plan.name.toLowerCase() === showPlanOnFlyout?.plan_name.toLowerCase()
      );
      if (planData) {
        planData[FutureData.ELEVATION] = showPlanOnFlyout?.elevation;
        lotInfo.homes_plans = [planData];
      }
    }
  }
  async fetchPlatmapCoordinates(neighborhoodId: string, header: HeaderData) {
    try {
      const res = await apiFetchPlatmapCordinates(neighborhoodId);
      const { platmap } = this;
      if (this.isPlatMapValid()) {
        const resLots = await apiFetchLots(this.neighborhoodId, "");
        this.lotDetails = resLots.result as LotDetails;
        this.setAllAmenities(this.lotDetails.amenity);
        this.setUnderlay(this.platmap.underlay_on);
      } else {
        this.notFound = true;
      }
      this.hideLoader();
    } catch (error) {
      this.platmap = {} as Platmap;
      this.lotDetails = {} as LotDetails;
      this.hideLoader();
      this.notFound = true;
    }
  }
  setPrintModal(value: boolean) {
    this.isOpenPrintModal = value;
  }
  isKioskMode() {
    return !(!this.$route.query.kiosk || this.$route.query.kiosk === "false");
  }
  setFooterState(value: boolean) {
    this.isOpenFooter = value;
  }
}
